import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="bg-accent-50 border border-accent-200 rounded-xl p-6 md:p-10 max-w-3xl mx-auto">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-9 h-9 rounded-full bg-accent-200 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-lg text-accent-700"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950">
              Important Notice
            </h3>
          </div>

          <p className="text-sm text-foreground-700 leading-relaxed mb-4">
            This website is an independent educational resource about mulebuy spreadsheet systems. We provide guides, comparisons, and safety analysis to help you understand how mulebuy spreadsheet platforms work. We do not operate any mulebuy spreadsheet service or handle payments. All external links to third-party shopping platforms are provided for reference only.
          </p>

          <p className="text-sm text-foreground-600 leading-relaxed">
            Always verify third-party services before making transactions. We recommend reading our{' '}
            <Link
              to="/mulebuy-spreadsheet-complete-guide"
              className="text-primary-600 hover:text-primary-700 underline underline-offset-2 cursor-pointer"
            >
              complete mulebuy spreadsheet safety guide
            </Link>
            {' '}before using any agent-based shopping platform.
          </p>
        </div>
      </div>
    </section>
  );
}